import React, { Suspense, useState, useEffect } from 'react';
import styled from 'styled-components';
import { HEADER_HEIGHT_PX, TEXTBLOCK_HEIGHT_PX, ADS_WIDTH_PX, BOARD_OFFSET_PX } from '../../assets/const';
import InfoModal from '../../components/info-modal/info-modal.component';

// Lazy loading
const Ads = React.lazy(() => import('../../components/ads/ads.component'));
const Board = React.lazy(() => import('../../components/board/board.component'));
const Header = React.lazy(() => import('../../components/header/header.component'));
const MenuOverlay = React.lazy(() => import('../../components/menu-overlay/menu-overlay.component'));
const InfoBlock = React.lazy(() => import('../../components/info-block/info-block.component'));

const HomeDiv = styled.div`
    display: flex;
    flex-direction: ${p => (p.$landscape ? 'row' : 'column')};
    height: 100vh;
    width: 100vw;
    overflow: hidden;
`;

const MainContent = styled.main`
    display: flex;
    flex-direction: column;
`;

const LoadingDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

const HomePage = () => {
    const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const landscape = size.height - (HEADER_HEIGHT_PX + TEXTBLOCK_HEIGHT_PX) < size.width;

    const availableH = size.height - (HEADER_HEIGHT_PX + TEXTBLOCK_HEIGHT_PX);
    const availableW = size.width - ADS_WIDTH_PX;
    const boardWidth = landscape ? Math.min(availableH, availableW) : Math.min(size.height - BOARD_OFFSET_PX, size.width);

    return (
        <HomeDiv $landscape={landscape}>
            <Suspense fallback={<LoadingDiv>Laddar...</LoadingDiv>}>
                <MainContent>
                    <Header $boardWidth={boardWidth} />
                    <Board $boardWidth={boardWidth} width={size.width} height={size.height} $landscape={landscape} />
                    <InfoBlock />
                </MainContent>
                <Ads width={size.width} height={size.height} $landscape={landscape} />
                <MenuOverlay />
            </Suspense>
            <InfoModal />
        </HomeDiv>
    );
};

export default HomePage;